<mat-toolbar class="header">
  <div class="content filter">
    <mat-icon (click)="backButton()" [inline]="true" class="material-icons back" svgIcon="ic-close-square">
    </mat-icon>
  </div>
</mat-toolbar>